module.exports = __webpack_public_path__ + "img/4.f6d26dc2.jpg";